import { getTournament } from "../../../services/api";
import { getResults, getMatches, getTftMatches } from '../../../services/api'
import {TFT} from "../../../constants/tournament/types";
export default {
  async getTournament ({ commit }, id) {
    await getTournament(id).then(async response => {
      if (response.data) {
        await commit('SET_TOURNAMENT', response.data)
      }
    })
  },
  getResults ({ commit }, id) {
    return getResults(id)
      .then(results => commit('SET_RESULTS', results.data))
  },
  async getMatches ({ commit, rootGetters, state }, id) {
    if (state.tournament.type === TFT) {
      return await getTftMatches(id)
        .then(async matches => {
          await commit('SET_MATCHES', matches.data.data)
        })
    } else {
      return await getMatches(id)
        .then(async matches => {
          await commit('SET_MATCHES', matches.data.data)
        })
    }

  },
}
